import React from "react";
import PropTypes from "prop-types";
import "./DashboardFeed.scss";
import FeedList from "./FeedList";
import { Skeleton } from "@mui/material";
import { dummyData } from './DummyData';
import EmptyStateOverlay from "../EmptyStateOverlay/EmptyStateOverlay";

export default function DashboardFeed({ feedJson, underpaymentSummary, handleOpen, setFeedData, onOpenUnderpaymentPreview}) {
  const hasData = feedJson?.length > 0;
  return (
    <div className="dashboard-feed">
      <div className="dashboard-feed-title">ProScore Feed</div>
      <div className="dashboard-feed-content">
        { typeof(feedJson) !== 'undefined' ?
        (
        <div style={{ position: 'relative', height: '100%' }}>
          <FeedList feedJson={!hasData ? dummyData : feedJson} underpaymentSummary={underpaymentSummary} handleOpen={handleOpen} setFeedData={setFeedData} onOpenUnderpaymentPreview={onOpenUnderpaymentPreview} />
          {!hasData && <EmptyStateOverlay message="Not enough feed data available" />}
        </div>
        )
          : <Skeleton variant="rectangular" width={'100%'} height={'calc(100% - 60px)'} sx={{ marginTop: '10px' }} />}
      </div>
    </div>
  );
}

DashboardFeed.propTypes = {
  feedJson: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      date: PropTypes.string
    })
  ).isRequired,
  handleOpen: PropTypes.func.isRequired,
  setFeedData: PropTypes.func.isRequired,
  onOpenUnderpaymentPreview: PropTypes.func
};